import React, { FC } from 'react';
import { Body, Box, Flex, Glyph } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { useFlowTools } from 'flowTools/useFlowTools';

type FlightUnavailableBannerProps = {
  isBrokenFlow?: boolean;
  content?: string;
};

const FlightUnavailableBanner: FC<FlightUnavailableBannerProps> = ({
  isBrokenFlow,
  content,
}) => {
  const { t } = useTranslation();
  const { isDesktop } = useFlowTools();

  const contentColor = isDesktop ? 'warning.70' : 'neutral.0';

  return (
    <Box
      marginY={isDesktop ? '0' : 'base'}
      borderRadius={isDesktop ? 'regular' : 'small'}
      sx={{
        backgroundColor: isDesktop ? 'warning.20' : 'warning.50',
      }}
    >
      <Flex>
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          padding={'small'}
        >
          <Glyph
            data-testid="alternative-itinerary-unavailable-banner-warning-icon"
            category="Alerts"
            name="Warning"
            color={contentColor}
            size={isDesktop ? 'small' : 'medium'}
          />
        </Flex>
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <Body
            type={isDesktop ? 'xSmall' : 'small'}
            sx={{
              color: contentColor,
            }}
          >
            {isBrokenFlow
              ? t('alternativeBrokenFlow.title.large.issue')
              : content
              ? content
              : t(
                  `alternativeItinerary.nonIssuable.flightUnavailable${
                    isDesktop ? '.large' : 'short'
                  }`
                )}
          </Body>
        </Flex>
      </Flex>
    </Box>
  );
};

export default FlightUnavailableBanner;
